/**
 * CoachingUX launcher factory for Web SDK
 */
import * as Api from "@ms-ofb/officefloodgatecore/dist/src/Api/Api";
import * as Configuration from "./../Configuration/Configuration";
import { getDynamicSetting } from "../Configuration/DynamicConfiguration";
import * as Constants from "../Constants";
import * as DomUtils from "../Window/DomUtils";
import * as Window from "../Window/Window";
import * as Logging from "../Logging/Logging";
import * as AssetsProvider from "../TargetedMessaging/AssetsProvider";
import { isNOU } from "../Utils";
// web surfaces script url load promise
let WebSurfacesScriptPromise;
function createwebSurfacesScriptPromise() {
  if (!WebSurfacesScriptPromise) {
    const webSurfacesLink = getDynamicSetting("WebSurfacesLink" /* webSurfacesLink */, Constants.DynamicScriptUrls.WebSurfacesLink);
    WebSurfacesScriptPromise = DomUtils.loadScript(webSurfacesLink, null);
  }
}
export default class CoachingUXLauncherFactory {
  makeSurveyLauncher(survey) {
    if (this.AcceptsSurvey(survey)) {
      return new CoachingUXLauncher(survey);
    }
    return null;
  }
  AcceptsSurvey(survey) {
    if (!isNOU(survey) && survey.getType() === Api.ISurvey.Type.GenericMessagingSurface && survey.getLauncherType().toLocaleLowerCase() === CoachingUXLauncherFactory.LAUNCHER_TYPE) {
      return true;
    }
    return false;
  }
}
CoachingUXLauncherFactory.LAUNCHER_TYPE = "coachingux";
export class CoachingUXLauncher {
  constructor(survey) {
    var _a;
    this.survey = survey;
    // pre-load web surface package if there are any critical campaigns
    if (!WebSurfacesScriptPromise && survey && survey.getSurveyInfo && ((_a = survey.getSurveyInfo()) === null || _a === void 0 ? void 0 : _a.getBusinessLevel()) === Api.ISurveyInfo.BusinessLevel.Critical) {
      setTimeout(createwebSurfacesScriptPromise, 1000);
    }
  }
  launch() {
    const surveyInfo = this.survey && this.survey.getSurveyInfo();
    const surveyMetadata = surveyInfo && surveyInfo.getMetadata();
    const contentMetadata = surveyMetadata && surveyMetadata.getContentMetadata();
    if (!contentMetadata) {
      return;
    }
    const startTime = new Date();
    const getWebSurfacesInstance = () => {
      const windowInstance = Window.getGlobal();
      return windowInstance && windowInstance.OfficeWebSurfaces;
    };
    const renderWebSurface = uxInitOptions => {
      const officeWebSurfaces = getWebSurfacesInstance();
      if (uxInitOptions) {
        officeWebSurfaces.Initialize(uxInitOptions);
      }
      officeWebSurfaces.RemoveSurface();
      officeWebSurfaces.RenderSurface(contentMetadata, null /* targetElementId */, surveyInfo.getBackEndId());
    };
    const logErrorEvent = error => {
      Logging.getLogger().logEvent(Logging.EventIds.WebSurfaces.Common.Error.VALUE, 1 /* Critical */, {
        ErrorMessage: "Error loading websurfaces" + (error && error.message ? ": " + error.message : ""),
        TimeMilliseconds: Date.now() - +startTime
      });
    };
    try {
      if (getWebSurfacesInstance()) {
        renderWebSurface();
        return;
      }
      createwebSurfacesScriptPromise();
      // if UX package isn't already loaded, download package and render surface
      WebSurfacesScriptPromise.then(() => {
        const initOptions = Configuration.get().getCommonInitOptions();
        const floodgateInitOptions = Configuration.get().getFloodgateInitOptions();
        const surveyActivatedCallback = floodgateInitOptions && floodgateInitOptions.onSurveyActivatedCallback;
        const beaconCallback = beaconParameters => {
          if (beaconParameters) {
            return AssetsProvider.get().setCampaignAction(beaconParameters);
          }
        };
        const uxOptions = Object.assign(Object.assign(Object.assign({}, initOptions), floodgateInitOptions), {
          beaconCallback,
          surfaceInitTime: startTime,
          surfaceId: surveyInfo.getBackEndId(),
          logSessionId: Configuration.get().getSdkSessionId(),
          logSettings: getDynamicSetting("LogLevelSettings" /* logLevelSettings */, undefined),
          renderer: surveyActivatedCallback,
          renderCallback: surveyActivatedCallback && surveyActivatedCallback.onTeachingCampaignRender
        });
        renderWebSurface(uxOptions);
      }).catch(error => {
        logErrorEvent(error);
      });
    } catch (error) {
      logErrorEvent(error);
    }
  }
}